import {useQuery} from "@tanstack/react-query";
import {detailAccountApi} from "../../../../api/account/AccountApi";

const init = {
    userId: 0,
    loginId: "",
    contactNo: "",
    crmId: "",
    password: null,
    userName: "",
    title: "",
    phoneNo: "",
    extensionNo: "",
    companyId: "",
    companyName: "",
    coEmail: "",
    remark: "",
    departmentId: "",
    departmentName: "",
    teamId: "",
    teamName: "",
    positionId: 0,
    dutyGroupId: 0,
    modAt: "",
    regAt: "",
    deleteFlag: "",
    dutyGroupName: "",
    roleName: "",
    dutyGroupTypeName: "",
    orgName: "",
    inOutFlag: 0,
}

export const useReadUserAccountDetail = (param: number) => {
    const {data} = useQuery({
        queryKey: ["readUserAccountDetailInModal", param],
        queryFn: async () => await detailAccountApi({userId: param}),
        select: (res) => res?.data.result ?? init,
        enabled: param !== 0
    });

    return {data};
};
